// extracted by css-extract-rspack-plugin
export default {"cls1":"common-cls1_SrR","cls2":"common-cls2_A5E common-cls1_SrR"};